import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Heading } from '@change-corgi/design-system-legacy/typography';

export const PageHeading: React.FC = () => {
	return (
		<>
			<Heading as="div" size="h2" mb={8}>
				<Translate value="fe.pages.redirect.intro" />
			</Heading>
			<Heading as="h1" size="h1" mb={32}>
				<Translate value="fe.pages.redirect.heading" />
			</Heading>
		</>
	);
};
